import { useEffect, useState } from "react";
import { isEmpty } from "remeda";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { ImportantNote } from "@/components/ui/importantNote";
import { Typography } from "@/components/ui/typography";
import { ExpandableSection } from "@/pages/admin/compositeJob/components";
import useCUCompositeJobStore from "@/store/useCUCompositeJobStore";

const desiredLayerCountOptions = [
  {
    label: "Repairing Odd Geometry such as Leak Repair Clamps",
    value: "oddGeometry",
  },
  {
    label: "No surface prep can be performed on the component",
    value: "noSurface",
  },
  {
    label: "Material is not steel e.g. PVC, plastic, fiberglass",
    value: "notSteel",
  },
  {
    label: "Defect is unknown or cannot be measured",
    value: "unknown",
  },
  {
    label: "Defect is extremely large e.g. large sections of the component are missing",
    value: "extremelyLarge",
  },
];

const cardName = "complianceChecks";
export function CompliantCheck() {
  const { sections, toggleExpandableSection, setCompliantCheck } = useCUCompositeJobStore();
  const savedComplianceChecks = sections.complianceChecks;
  const [desired_layer_count_options, setDesired_layer_count_options] = useState<Array<string>>([]);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (
      isEmpty(desired_layer_count_options) &&
      savedComplianceChecks.isDataFilled &&
      "desired_layer_count_options" in savedComplianceChecks.data &&
      savedComplianceChecks.data.desired_layer_count_options
    ) {
      setDesired_layer_count_options(savedComplianceChecks.data.desired_layer_count_options);
    }
  }, [savedComplianceChecks.isDataFilled]);
  const isNonCompliantRecommended =
    desired_layer_count_options.length > 0 && !desired_layer_count_options.includes("none");

  return (
    <ExpandableSection
      status={savedComplianceChecks.status}
      setIsExpanded={() => toggleExpandableSection(cardName)}
      title="Compliant Checks"
    >
      <Typography variant="text-lg" weight="semibold" className="text-gray-900">
        Check any that apply
      </Typography>
      <div className="my-6 flex flex-col gap-4">
        {desiredLayerCountOptions.map((o) => {
          return (
            <Checkbox
              key={o.value}
              checked={desired_layer_count_options.includes(o.value)}
              onChange={(value) => {
                setDesired_layer_count_options((prevState) =>
                  value ? [...prevState, o.value].filter((a) => a !== "none") : prevState.filter((v) => v !== o.value)
                );
              }}
              label={o.label}
            />
          );
        })}

        <Checkbox
          checked={desired_layer_count_options.includes("none")}
          onChange={(value) => {
            setDesired_layer_count_options(() => (value ? ["none"] : []));
          }}
          label="None of the above apply"
        />
      </div>
      {isNonCompliantRecommended && (
        <ImportantNote>Based on your selection, a non compliant repair is recommended</ImportantNote>
      )}
      {showError && <ImportantNote>You should select option</ImportantNote>}
      <Button
        onClick={() => {
          if (isEmpty(desired_layer_count_options)) {
            setShowError(true);
          } else {
            setShowError(false);
            setCompliantCheck({ data: { desired_layer_count_options }, status: "done" });
          }
        }}
      >
        Save
      </Button>
    </ExpandableSection>
  );
}
